import React from 'react';

function Minus(props: any) {
    return (
        <svg
            className={props.className}
            height={props.height}
            width={props.width}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                fill={props.fill}
                d="M0 10h24v4h-24z"
            />
        </svg>
    );
}

export default Minus;
